import { Theme } from '../context/MuiColorModeContext'

export const DEFAULT_THEME = Theme.LIGHT
